// EXPIRED abonelikli kullanıcının EXPIRED durumdayken bile erişebileceği route'lar.
// Bu prefix'lerden biriyle başlayan yollar SubscriptionGate tarafından kısıtlanmaz:
// paket görüntüleme, satın alma, yenileme ve abonelik ekranları çalışmaya devam eder.
export const SUBSCRIPTION_ALLOWED_PREFIXES = [
  "/subscription", // details, plans, compare, upgrade, checkout, history, payment-success/fail
  "/profile",
  "/logout",
];

// Verilen pathname allowlist'te mi?
export const isSubscriptionAllowedPath = (pathname = "") =>
  SUBSCRIPTION_ALLOWED_PREFIXES.some((p) => pathname.startsWith(p));
